import {getToken} from "../Utils/Common";

// export function getProductManagementDataAPI() {
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/dashboard/v1/resources/product_management`, {
//             method: 'GET',
//             headers: {
//             'Authorization': 'Bearer ' + getToken(),
//         },
//         }).then( res => {return res.json();})
//             .catch((error) => {
//                 console.error('Error:', error);
//             });
// }

//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
let apilink = process.env.REACT_APP_BACKEND_API_URI

export async function getProductManagementDataAPI() {
    let link = apilink + "projects/" + "getproductmanagementdata";
    return await fetch(link, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({token: getToken()})
    }).then(data => data.json())
}